import ButtonWidget from "../../../components/elements/ButtonWidget"
import PaymentFailedGif from "../../../assets/gif/paymentfailed.gif";
import PageHeading from "../../../components/elements/PageHeading";
import {useUssdStatus} from "../../../contexts/UssdContext";
import {ErrorClass} from "../../../constants/ErrorConstants";

const FailedUssd = ()=>{
    const {showSelectBank, ussdStatus} = useUssdStatus()

    return (
        <div className="box">
            <div>
                <PageHeading title="Pay with USSD"
                             description="" className="mb-2"/>

                <img src={PaymentFailedGif} width={124} height={124} alt="Payment Failed"/>

                <div className="grey-container align-items-center">
                    {
                        ussdStatus.message === ErrorClass.FAILED_INITIALIZATION &&
                        <div className="text-xl fw-bold">
                            {ErrorClass.FAILED_INITIALIZATION_HEADING}
                        </div>
                    }

                    <div className="text-md grey-color">
                        {ussdStatus.message ? ussdStatus.message :
                            ErrorClass.FAILED_TRANSFER_PAYMENT
                        }
                    </div>
                </div>
            </div>

            <div>
                <ButtonWidget className="modal-btn" onClick={()=>{
                    showSelectBank()
                }}>
                    Retry
                </ButtonWidget>
            </div>
        </div>
    )
}

export default FailedUssd
